export enum MenuTypeEnum {
  MENU = "MENU",
  NAVBAR = "NAVBAR",
}
